import React, { useContext, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import coin from "../../assets/coin.webp";
//MUI
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
//blurbackground mui
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import { DataGrid, GridColDef, GridRowSelectionModel } from "@mui/x-data-grid";
import CheckIcon from "@mui/icons-material/Check";

import { baseServiceUrl, urls } from "../../environment";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import useUserStore from "../../stores/useUserStores";
//MUI

const SamplePaper = () => {
  const toastId = React.useRef<any>(null);
  const sendingnotify = (msg: any) => (toastId.current = toast.loading(msg));
  const dismiss = () => toast.dismiss(toastId.current);
  const errornotify = (msg: any) => toast.error(msg);
  const successnotify = (msg: any) => toast.success(msg);
  const [exam, setexam] = useState<any>({});
  const { token, setLoading } = useUserStore();
  const [Subjectlist, setSubjectList] = useState<any[]>([]);
  const [question, setQuestion] = useState<any[]>([]);
  const [tab, setTab] = useState<any>(0);
  const [rowSelectionModel, setRowSelectionModel] =
    useState<GridRowSelectionModel>([]);
  const navigate = useNavigate();
  const [select, setSelect] = useState<any>([]);
  const columns: GridColDef[] = [
    {
      field: "question",
      headerName: "Question",
      flex: 1,
    },
    {
      field: "marks",
      headerName: "Marks",
      type: "number",
      width: 200,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "negetive_mark",
      headerName: "Negetive Mark",
      type: "number",
      width: 200,
      align: "center",
      headerAlign: "center",
    },
  ];
  useEffect(() => {
    try {
      setLoading(true);
      (async () => {
        const response = await axios.get(baseServiceUrl + urls.getSubjectUrl, {
          headers: {
            Authorization: "Bearer " + token,
          },
        });
        setLoading(false);
        if (response.data) {
          setSubjectList(response.data);
        }
      })();
    } catch (err: any) {
      setLoading(false);
      errornotify(
        (typeof err?.response?.data?.errors[0] == "string"
          ? err?.response?.data?.errors[0]
          : err?.response?.data?.errors[0]?.msg) ||
          "Error encounter. Please try again."
      );
    }
  }, []);
  useEffect(() => {
    if (Subjectlist.length > 0) {
      (async () => {
        try {
          setLoading(true);
          const targetSubject = Subjectlist[tab];
          const response = await axios.get(
            baseServiceUrl + urls.getQuestionUrl + targetSubject.domain_key,
            {
              headers: {
                Authorization: "Bearer " + token,
              },
            }
          );
          if (response.data) {
            setQuestion(
              response?.data?.map((item: any, index: any) => ({
                question: item.ques.question,
                marks: item?.ques?.marks,
                negetive_mark: item.ques.negetive_mark,
                options: item.ans.map((o: any, i: number) => ({
                  val: o.options_value + " " + o.anwser_field,
                  iscorrect: o.correct_flag,
                })),
                id: item.ques.id,
              }))
            );
            setRowSelectionModel(select);
          }

          setLoading(false);
        } catch (err: any) {
          setLoading(false);
          errornotify(
            (typeof err?.response?.data?.errors[0] == "string"
              ? err?.response?.data?.errors[0]
              : err?.response?.data?.errors[0]?.msg) ||
              "Error encounter. Please try again."
          );
        }
      })();
    }
  }, [tab, Subjectlist]);
  const createExam = () => {
    if (!exam.title) {
      errornotify("Please add Title");
      return;
    }
    if (!exam.category) {
      errornotify("Please add category");
      return;
    }
    if (!exam.duration) {
      errornotify("Please add duration");
      return;
    }
    if (!exam.exam_start_time) {
      errornotify("Please add exam start time");
      return;
    }
    if (!exam.exam_end_time) {
      errornotify("Please add exam start time");
      return;
    }
    if (!exam.description) {
      errornotify("Please add description");
      return;
    }
    if (!exam.instructions) {
      errornotify("Please add instructions");
      return;
    }
    if (select.length <= 0) {
      errornotify("Please add some question");
      return;
    }
    if (!exam.total_marks) {
      errornotify("Please add total marks");
      return;
    }
    if (select.total_questions) {
      errornotify("Please add total question");
      return;
    }
    let payload: any = {
      title: exam.title,
      description: exam.description,
      duration: +exam.duration,
      questions: select,
      category: exam.category,
      instructions: exam.instructions,
      total_marks: +exam.total_marks,
      total_questions: +exam.total_questions,
      exam_start_time: moment(exam.exam_start_time).format(
        "DD-MM-YYYY HH:MM:SS"
      ),
      exam_end_time: moment(exam.exam_end_time).format("DD-MM-YYYY hh:mm:ss"),
    };
    setLoading(true);
    (async () => {
      try {
        const response = await axios.post(
          baseServiceUrl + urls.createExamUrl,
          payload,
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );
        setLoading(false);
        if (response.status == 200) {
          successnotify("Test successfully addded.");
          navigate("/admin-dashboard/test-list");
        }
      } catch (err: any) {
        setLoading(false);
        errornotify(
          err?.response?.data?.message || "Error encounter. Please try again."
        );
      }
    })();
  };

  return (
    <>
      {/* <Toaster position="bottom-left" reverseOrder={false} /> */}
      <section
        id="create-question"
        className={`min-h-screen flex items-center py-4 justify-center`}
      >
        <div className="container w-full md:w-[90%]  lg:w-[80%] mx-auto ">
          <div className="bg-white rounded shadow-xl drop-shadow-md p-4 px-4 md:p-8 flex flex-col  w-full">
            <p className="md:text-xl  text-lg font-semibold">Add New Tests</p>
            <div className="flex flex-col mt-8 ml-3 md:text-base text-sm">
              <label htmlFor="subject" className="text-sm">
                Test Name<span className="text-red-700">*</span>
              </label>
              <input
                value={exam?.title}
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-100 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter Test Name"
                onChange={(e) => setexam({ ...exam, title: e.target.value })}
              />
            </div>
            <div className="flex flex-row">
              <div className="flex flex-1 flex-col mt-4 ml-3 md:text-base text-sm">
                <label htmlFor="subject" className="text-sm">
                  Category<span className="text-red-700">*</span>
                </label>
                <input
                  value={exam?.category}
                  className="block p-2.5 w-full text-sm text-gray-900 bg-gray-100 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter Category"
                  onChange={(e) =>
                    setexam({ ...exam, category: e.target.value })
                  }
                />
              </div>
              <div className="flex flex-1 flex-col mt-4 ml-3 md:text-base text-sm">
                <label htmlFor="subject" className="text-sm">
                  Duration (Minutes)<span className="text-red-700">*</span>
                </label>
                <input
                  type="number"
                  value={exam?.duration}
                  className="block p-2.5 w-full text-sm text-gray-900 bg-gray-100 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter duration"
                  onChange={(e) =>
                    setexam({ ...exam, duration: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="flex flex-row">
              <div className="flex flex-1 flex-col mt-4 ml-3 md:text-base text-sm">
                <label htmlFor="subject" className="text-sm">
                  Total Questions<span className="text-red-700">*</span>
                </label>
                <input
                  value={exam?.total_questions}
                  className="block p-2.5 w-full text-sm text-gray-900 bg-gray-100 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter Total Questions"
                  onChange={(e) =>
                    setexam({ ...exam, total_questions: e.target.value })
                  }
                />
              </div>
              <div className="flex flex-1 flex-col mt-4 ml-3 md:text-base text-sm">
                <label htmlFor="subject" className="text-sm">
                  Total Marks<span className="text-red-700">*</span>
                </label>
                <input
                  type="number"
                  value={exam?.total_marks}
                  className="block p-2.5 w-full text-sm text-gray-900 bg-gray-100 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter Total Marks"
                  onChange={(e) =>
                    setexam({ ...exam, total_marks: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="flex flex-row">
              <div className="flex flex-1 flex-col mt-4 ml-3 md:text-base text-sm">
                <label htmlFor="subject" className="text-sm">
                  Exam Start Time<span className="text-red-700">*</span>
                </label>
                <input
                  type="datetime-local"
                  value={exam?.exam_start_time}
                  className="block p-2.5 w-full text-sm text-gray-900 bg-gray-100 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter duration"
                  onChange={(e) =>
                    setexam({ ...exam, exam_start_time: e.target.value })
                  }
                />
              </div>
              <div className="flex flex-1 flex-col mt-4 ml-3 md:text-base text-sm">
                <label htmlFor="subject" className="text-sm">
                  Exam End Time<span className="text-red-700">*</span>
                </label>
                <input
                  type="datetime-local"
                  value={exam?.exam_end_time}
                  className="block p-2.5 w-full text-sm text-gray-900 bg-gray-100 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter duration"
                  onChange={(e) =>
                    setexam({ ...exam, exam_end_time: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="flex flex-row">
              <div className="flex flex-1 flex-col mt-4 ml-3">
                <label htmlFor="message" className="text-sm">
                  Description<span className="text-red-700">*</span>
                </label>
                <textarea
                  id="message"
                  rows={4}
                  value={exam.description}
                  className="block p-2.5 w-full text-sm text-gray-900 bg-gray-100 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                  onChange={(e) => {
                    setexam({ ...exam, description: e.target.value });
                  }}
                ></textarea>
              </div>
              <div className="flex flex-1 flex-col mt-4 ml-3">
                <label htmlFor="message" className="text-sm">
                  Instructions<span className="text-red-700">*</span>
                </label>
                <textarea
                  id="instructions"
                  rows={4}
                  value={exam.instructions}
                  className="block p-2.5 w-full text-sm text-gray-900 bg-gray-100 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                  onChange={(e) => {
                    setexam({ ...exam, instructions: e.target.value });
                  }}
                ></textarea>
              </div>
            </div>
            <div className="bg-white rounded  mt-4 ml-3  flex flex-col">
              <div className="flex flex-row items-center justify-between">
                <p className="text-xl font-semibold mb-1">Select Questions</p>
              </div>

              <div className="mb-3">
                <Box
                  className="border-b-2"
                  sx={{
                    bgcolor: "background.paper",
                  }}
                >
                  <Tabs
                    value={tab}
                    onChange={(event: any, newValue: any) => setTab(newValue)}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                  >
                    {Subjectlist.map((item: any, key: number) => (
                      <Tab label={item.domain_value} key={key} />
                    ))}
                  </Tabs>
                </Box>
              </div>
            </div>
            <div className="mb-6">
              <DataGrid
                sx={{
                  ".MuiDataGrid-columnHeader": {
                    backgroundColor: "#E5E7EB",
                  },
                  ".MuiDataGrid-columnHeaderTitle": {
                    fontWeight: "500",
                    fontSize: 16,
                    color: "#23304a",
                  },
                }}
                rows={question}
                columns={columns}
                checkboxSelection
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 5 },
                  },
                }}
                pageSizeOptions={[5, 10]}
                rowSelectionModel={rowSelectionModel}
                onRowSelectionModelChange={(props) => {
                  setRowSelectionModel(props);
                  let unionSelect = select.filter(
                    (m: any) => !question.find((n) => n.id == m)
                  );
                  setSelect([...props, ...unionSelect]);
                }}
              />
            </div>
            <div className="flex items-center justify-center">
              <button
                type="button"
                className="mt-10 w-[30%] bg-gray-800 hover:bg-opacity-90 text-white font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                onClick={() => createExam()}
              >
                Submit Question
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SamplePaper;
